var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "div",
        { staticClass: "subTitle" },
        [
          _c(
            "el-link",
            {
              attrs: {
                icon: "el-icon-arrow-left",
                underline: false,
                href: "#/officeLocations"
              }
            },
            [_vm._v("Content Management - Office Locations")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "h3",
        {
          staticClass: "title",
          attrs: { content: "edit", placement: "bottom" }
        },
        [_vm._v("\n    Create Office Locations\n  ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "detailContent" },
        [
          _c(
            "el-form",
            {
              ref: "formLocation",
              attrs: {
                "label-width": "50%",
                "label-position": "left",
                model: _vm.formLocation,
                rules: _vm.formLocationRules
              }
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Country / Region", prop: "country" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { filterable: "" },
                              model: {
                                value: _vm.formLocation.country,
                                callback: function($$v) {
                                  _vm.$set(_vm.formLocation, "country", $$v)
                                },
                                expression: "formLocation.country"
                              }
                            },
                            _vm._l(_vm.countryList, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.name,
                                  value: item.countryId
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Office Name / City (EN)",
                            prop: "cityEn"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "Please enter",
                              maxlength: "50"
                            },
                            model: {
                              value: _vm.formLocation.cityEn,
                              callback: function($$v) {
                                _vm.$set(_vm.formLocation, "cityEn", $$v)
                              },
                              expression: "formLocation.cityEn"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Office Name / City (JP)",
                            prop: "cityJp"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "Please enter",
                              maxlength: "50"
                            },
                            model: {
                              value: _vm.formLocation.cityJp,
                              callback: function($$v) {
                                _vm.$set(_vm.formLocation, "cityJp", $$v)
                              },
                              expression: "formLocation.cityJp"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Office Name / City (TC)",
                            prop: "cityTc"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "Please enter",
                              maxlength: "50"
                            },
                            model: {
                              value: _vm.formLocation.cityTc,
                              callback: function($$v) {
                                _vm.$set(_vm.formLocation, "cityTc", $$v)
                              },
                              expression: "formLocation.cityTc"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Office Name / City (SC)",
                            prop: "citySc"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "Please enter",
                              maxlength: "50"
                            },
                            model: {
                              value: _vm.formLocation.citySc,
                              callback: function($$v) {
                                _vm.$set(_vm.formLocation, "citySc", $$v)
                              },
                              expression: "formLocation.citySc"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Office address (EN)",
                            prop: "addressEn"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "Please enter",
                              type: "textarea",
                              resize: "none",
                              maxlength: "150"
                            },
                            model: {
                              value: _vm.formLocation.addressEn,
                              callback: function($$v) {
                                _vm.$set(_vm.formLocation, "addressEn", $$v)
                              },
                              expression: "formLocation.addressEn"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Office address (JP)",
                            prop: "addressJp"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "Please enter",
                              type: "textarea",
                              resize: "none",
                              maxlength: "150"
                            },
                            model: {
                              value: _vm.formLocation.addressJp,
                              callback: function($$v) {
                                _vm.$set(_vm.formLocation, "addressJp", $$v)
                              },
                              expression: "formLocation.addressJp"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Office address (TC)",
                            prop: "addressTc"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "Please enter",
                              type: "textarea",
                              resize: "none",
                              maxlength: "150"
                            },
                            model: {
                              value: _vm.formLocation.addressTc,
                              callback: function($$v) {
                                _vm.$set(_vm.formLocation, "addressTc", $$v)
                              },
                              expression: "formLocation.addressTc"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Office address (SC)",
                            prop: "addressSc"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "Please enter",
                              type: "textarea",
                              resize: "none",
                              maxlength: "150"
                            },
                            model: {
                              value: _vm.formLocation.addressSc,
                              callback: function($$v) {
                                _vm.$set(_vm.formLocation, "addressSc", $$v)
                              },
                              expression: "formLocation.addressSc"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Post online", prop: "post" } },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: true },
                              model: {
                                value: _vm.formLocation.post,
                                callback: function($$v) {
                                  _vm.$set(_vm.formLocation, "post", $$v)
                                },
                                expression: "formLocation.post"
                              }
                            },
                            [_vm._v("On")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: false },
                              model: {
                                value: _vm.formLocation.post,
                                callback: function($$v) {
                                  _vm.$set(_vm.formLocation, "post", $$v)
                                },
                                expression: "formLocation.post"
                              }
                            },
                            [_vm._v("Off")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Order", prop: "order" } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "2" },
                            model: {
                              value: _vm.formLocation.order,
                              callback: function($$v) {
                                _vm.$set(_vm.formLocation, "order", $$v)
                              },
                              expression: "formLocation.order"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: { padding: "25px 0" },
          attrs: { type: "flex", justify: "end", gutter: 20 }
        },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _vm.showSave
                ? _c(
                    "el-button",
                    {
                      staticClass: "reset",
                      staticStyle: { width: "100%" },
                      on: { click: _vm.handleCancel }
                    },
                    [_vm._v("Cancel")]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _vm.showSave
                ? _c(
                    "el-button",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { type: "primary" },
                      on: { click: _vm.handleCreate }
                    },
                    [_vm._v("Create")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0bc35951", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bc35951","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/location/createOfficeLocation.vue
// module id = null
// module chunks = 